/**
  * @desc You can use it to do custom facet switcher
  *
  * @window[fbjsVariableName] - this is fbjs
    window.fbjsName = new Search.default({...})
  *
  * .fbjs-facet-switcher should have:
  * data-facet-query-string-param-name
  * data-facet-selected-category-values - you can split values by using ","
  * data-fbjs-variable-name - name of fbjs variable
  *
  * remember to have empty facet array in "activeFacetsOnStart"
  * example:
        activeFacetsOnStart: {
            'f.pageType|pageType': [],
        },
  *
  * HTML item example:
    <li>
        <input
            class="sq-form-field fbjs-facet-switcher"
            data-facet-query-string-param-name="f.pageType|pageType"
            data-facet-selected-category-values="expertise - software, expertise - product"
            data-fbjs-variable-name="searchAZ"
            type="checkbox"
            name="a-z_2"
            id="a-z_2"
            value="2"
        >
        <label for="a-z_2">Software & Products</label>
    </li>
  */

export const fbjsFacetSwitcher = async () => {
    const fbjsFacetSwitcherArray = document.querySelectorAll(
        ".fbjs-facet-switcher"
    );

    if (fbjsFacetSwitcherArray.length) {
        [...fbjsFacetSwitcherArray].map((el) => {
            el.addEventListener("click", (e) => {
                const target = e.currentTarget,
                    fbjsVariableName = target.getAttribute(
                        "data-fbjs-variable-name"
                    ),
                    searchFacetName = target.getAttribute(
                        "data-facet-query-string-param-name"
                    ),
                    searchFacetVals = target
                        .getAttribute("data-facet-selected-category-values")
                        .replace(/&/gi, "&amp;")
                        .split(","),
                    arrayOfDisplaingFacets =
                        window[fbjsVariableName]?.search?.activeFacets[
                            searchFacetName
                        ]?.value;
                if (arrayOfDisplaingFacets?.includes(searchFacetVals[0])) {
                    [...searchFacetVals].map((el) => {
                        const indexOfSearchFacet =
                            arrayOfDisplaingFacets?.indexOf(el);
                        window[fbjsVariableName]?.search?.activeFacets[
                            searchFacetName
                        ]?.value?.splice(indexOfSearchFacet, 1);
                    });
                } else {
                    [...searchFacetVals].map((el) => {
                        window[fbjsVariableName]?.search?.activeFacets[
                            searchFacetName
                        ]?.value?.push(el);
                    });
                }
                window[fbjsVariableName]?.doSearch(true, true);
            });
        });
    }
};

export const fbjsFacetSwitcherUnticker = () => {
    const activeFacets = document.querySelector(".c-filters .active-facets");
    if (activeFacets) {
        activeFacets.addEventListener("click", (e) => {
            if (
                e.target.nodeName === "SPAN" &&
                e.target.getAttribute("param") &&
                e.target.getAttribute("name")
            ) {
                [...document.getElementsByClassName("dropdown-list")].forEach(
                    (el) => {
                        const input = el.querySelector(
                            `input[data-facet-query-string-param-name="${e.target.getAttribute(
                                "param"
                            )}"][data-facet-selected-category-values="${e.target.getAttribute(
                                "name"
                            )}"]`
                        );
                        if (input) {
                            input.checked = false;
                            if (
                                input
                                    .closest("li")
                                    .classList.contains("dropdownActive")
                            ) {
                                input
                                    .closest("li")
                                    .classList.remove("dropdownActive");
                            }
                        }
                    }
                );
            }
        });
    }
};
